import makeStyles from "@material-ui/core/styles/makeStyles";
import pageContainer from "../../styles/pageContainer";

export const useStyles = makeStyles(theme => ({
  container: {
    ...pageContainer(theme),
    flexDirection: "column"
  }
}));
